import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DropdownDoubleControl } from 'app/shared/dynamic-forms/form-models/dropdown-double-control';

@Component({
  selector: 'hb-df-dropdown-double',
  templateUrl: './dropdown-double.component.html',
  styleUrls: ['./dropdown-style.scss'],
})
export class DropdownDoubleComponent {
  @Input() control: DropdownDoubleControl;
  @Input() formGroup: FormGroup;

  @Output() onOverrideValue = new EventEmitter();

  constructor() {}

  public overrideValue() {
    this.onOverrideValue.emit();
  }
}
